import React, { useState, Component } from 'react';




class Heading extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);

    // this.state = {
    //   example: someInfo,
    // };
  }
  

  render() {
    const { width, height, cx, content, headingLevel } = this.props;
    const Title = headingLevel;

    return (
      <Title className={`w-${width} h-${height} ${cx}`}>{content}</Title>
    
    );
  }
}


export default Heading;